module.exports = __webpack_public_path__ + "PS2icon.png?3aeeeecbc98c96bae7c3a38d42c8249a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/PS2icon.png
// module id = 46
// module chunks = 0